document.addEventListener('DOMContentLoaded', function () {
    const $stickyAddToCart = document.getElementById('sticky-add-to-cart');
    const $stickyAddToCartButton = document.getElementById('sticky-add-to-cart-button');
    const $originalProductName = document.querySelector('.product__title > h1');
    const $stickyProductName = document.getElementById('sticky-product-title');

    // The sticky bar markup only exists on product templates (theme.liquid renders
    // 'dtc-sticky-cta' there). Sections such as custom-product-standalone load this
    // script on page templates too, so bail out when the bar is absent.
    if (!$stickyAddToCart || !$stickyAddToCartButton || !$stickyProductName) {
        return;
    }

    window.onscroll = function () {
        const $addToCartButton = document.getElementById('add-to-cart-btn');

        if (!$addToCartButton && !$originalProductName) {
            console.warn('Critical element not found ($addToCartButton, $originalProductName)');
            return;
        }

        const rect = $addToCartButton.getBoundingClientRect();

        if (rect.top < 0) {
            // Trigger a location convert if reached this
            if (!window?.pdpStickyCta) {
                window.pdpStickyCta = true;
                window._conv_q = window._conv_q || [];
                window._conv_q.push(["executeExperiment", "100462593"]);
            }

            $stickyProductName.innerHTML = $originalProductName.innerText;
            $stickyAddToCartButton.innerHTML = $addToCartButton.innerText;
            $stickyAddToCart.style.display = 'flex';
        } else {
            $stickyAddToCart.style.display = 'none';
        }
    };

    // Add click event listener to stickyAddToCartButton
    $stickyAddToCartButton.addEventListener('click', function () {
        const $addToCartButton = document.getElementById('add-to-cart-btn');
        if ($addToCartButton) {
            $addToCartButton.click();
        }
    });
});


function showStickyAddToCart() {
    const $stickyAddToCart = document.getElementById('sticky-add-to-cart');

    if (!$stickyAddToCart) {
        return;
    }

    $stickyAddToCart.classList.remove('hidden');
}

showStickyAddToCart();
